import React from 'react';
import { AppBar, Container, Grid, Link, makeStyles } from '@material-ui/core';
import logo from '../../../assets/images/logo.svg';
import { HeaderAppBarStyle, HeaderContainerStyle } from './Header.style';
import { auth } from '../../../utils/auth';
import { useAuth } from '../../../contexts/AuthContext';

const whiteLink = makeStyles({
    root: {
        color: '#fff',
        cursor: 'pointer',
    },
});

const Header = (): JSX.Element => {
    const appBarClass = HeaderAppBarStyle();
    const containerClass = HeaderContainerStyle();
    const whiteLinkClass = whiteLink();

    const { session, loading } = useAuth();
    
    const handleMyAccount = (): void => {
        window.location.href = process.env.REACT_APP_MY_AIA_URL!;
    };

    return (
        <AppBar classes={{ root: appBarClass.root }} elevation={0} color="primary" position="sticky">
            <Container classes={{ root: containerClass.root }} maxWidth="lg">
                <Grid container direction="row" justify="space-between" alignItems="center">
                    <Grid item>
                        <Link href="http://www.aia.org/">
                            <img src={logo} alt="The American Institute of Architects" />
                        </Link>
                    </Grid>
                    {!loading && session?.authenticated && (
                        <Grid item>
                            <Link className={whiteLinkClass.root} onClick={handleMyAccount}>
                                My Account
                            </Link>
                        </Grid>
                    )}
                </Grid>
            </Container>
        </AppBar>
    );
};

export default Header;
